import React, {useState} from 'react'

const vorhanden = (wert) => wert !== null && wert !== undefined && String(wert).trim() !== "";

// Angaben wie "www.verein.de" ohne Protokoll würden sonst relativ zur Darthelfer-Seite geöffnet
function alsUrl(wert) {
    const url = String(wert).trim();
    return /^https?:\/\//i.test(url) ? url : "https://" + url;
}

// erkennt Adressen mit http(s):// oder www. im Fließtext
const LINK_MUSTER = /((?:https?:\/\/|www\.)[^\s<>"]+)/gi;
// Satzzeichen am Ende gehören meist zum Satz, nicht zur Adresse ("siehe www.verein.de.")
const SATZZEICHEN_AM_ENDE = /[.,;:!?)\]}'"]+$/;

/**
 * Macht Links in einem Text klickbar. Der restliche Text bleibt unverändert (Zeilenumbrüche über pre-line).
 */
function mitLinks(text) {
    const teile = String(text).split(LINK_MUSTER);
    return teile.map((teil, index) => {
        // durch die Gruppe im Muster stehen die Treffer an den ungeraden Stellen
        if (index % 2 === 0) {
            return <React.Fragment key={index}>{teil}</React.Fragment>;
        }
        const ende = teil.match(SATZZEICHEN_AM_ENDE);
        const adresse = ende ? teil.slice(0, -ende[0].length) : teil;
        return <React.Fragment key={index}>
            <a className="dhpt-text-link" href={alsUrl(adresse)} target="_blank" rel="noopener noreferrer">{adresse}</a>
            {ende ? ende[0] : ""}
        </React.Fragment>;
    });
}

function getSocialMedia(url) {
    const klein = url.toLowerCase();
    if (klein.includes("facebook.") || klein.includes("fb.com") || klein.includes("fb.me")) {
        return {label: "Facebook", icon: "pi pi-facebook"};
    }
    if (klein.includes("instagram.")) {
        return {label: "Instagram", icon: "pi pi-instagram"};
    }
    if (klein.includes("youtube.") || klein.includes("youtu.be")) {
        return {label: "YouTube", icon: "pi pi-youtube"};
    }
    if (klein.includes("tiktok.")) {
        return {label: "TikTok", icon: "pi pi-tiktok"};
    }
    if (klein.includes("twitter.") || klein.includes("x.com")) {
        return {label: "X", icon: "pi pi-twitter"};
    }
    return {label: "Social Media", icon: "pi pi-share-alt"};
}

function LinkKnopf({href, icon, label, extern}) {
    return <a className="dhpt-link-knopf" href={href}
              target={extern ? "_blank" : undefined} rel={extern ? "noopener noreferrer" : undefined}>
        <i className={icon} aria-hidden="true"/>
        <span>{label}</span>
        {extern && <i className="pi pi-external-link dhpt-link-knopf-extern" aria-hidden="true"/>}
    </a>
}

/**
 * Infos zum Event in der neuen Ansicht: Veranstaltung, Veranstalter (Links als Knöpfe) und Austragungsort.
 * Entspricht inhaltlich PublicTournamentDetailsTab der alten Ansicht.
 */
export default function InfosBereich({tournament}) {

    const [beschreibungOffen, setBeschreibungOffen] = useState(false);

    const t = tournament;
    const beschreibungLang = vorhanden(t.beschreibung) && t.beschreibung.length > 300;

    const getArt = () => {
        if (t.dyp) {
            return "DYP Turnier, Anmeldung als Einzelperson. Der Doppelpartner wird automatisch zugewiesen.";
        }
        return t.doppelturnier ? "Doppelturnier" : "Einzelturnier";
    }

    const hatVeranstalterDaten = vorhanden(t.homepage) || vorhanden(t.socialmedia) || vorhanden(t.email) || vorhanden(t.telefon);
    const hatAustragungsort = vorhanden(t.austragungsortBezeichnung) || vorhanden(t.austragungsortStrasse)
        || vorhanden(t.austragungsortPLZ) || vorhanden(t.austragungsortOrt);

    const getMapsUrl = () => {
        let adresse = [t.austragungsortPLZ, t.austragungsortOrt].filter(vorhanden).join(" ");
        if (vorhanden(t.austragungsortStrasse)) {
            adresse = t.austragungsortStrasse + ", " + adresse;
        } else if (vorhanden(t.austragungsortBezeichnung)) {
            adresse = t.austragungsortBezeichnung + ", " + adresse;
        }
        return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(adresse);
    }

    const socialMedia = vorhanden(t.socialmedia) ? getSocialMedia(t.socialmedia) : undefined;
    const telefonNummer = vorhanden(t.telefon) ? t.telefon.replace(/[^\d+]/g, "") : "";

    return <div className="dhpt-karten">
        <section className="dhpt-karte dhpt-karte-breit">
            <h3 className="dhpt-karte-titel"><span>Veranstaltung</span></h3>
            <dl className="dhpt-liste">
                <dt>Bezeichnung</dt><dd>{t.bezeichnung}</dd>
                {vorhanden(t.beginnMitUhrzeitString) && <><dt>Beginn</dt><dd>{t.beginnMitUhrzeitString}</dd></>}
                <dt>Status</dt><dd>{t.tournamentstatus}</dd>
                <dt>Art</dt><dd>{getArt()}</dd>
            </dl>
            {vorhanden(t.beschreibung) &&
                <div className="dhpt-beschreibung">
                    <div className={beschreibungLang && !beschreibungOffen ? "dhpt-beschreibung-text dhpt-beschreibung-zu" : "dhpt-beschreibung-text"}>
                        {mitLinks(t.beschreibung)}
                    </div>
                    {beschreibungLang &&
                        <button type="button" className="dhpt-text-knopf" aria-expanded={beschreibungOffen}
                                onClick={() => setBeschreibungOffen(!beschreibungOffen)}>
                            {beschreibungOffen ? "Weniger anzeigen" : "Mehr anzeigen"}
                            <i className={beschreibungOffen ? "pi pi-angle-up" : "pi pi-angle-down"} aria-hidden="true"/>
                        </button>
                    }
                </div>
            }
        </section>

        {hatVeranstalterDaten &&
            <section className="dhpt-karte">
                <h3 className="dhpt-karte-titel"><span>Veranstalter</span></h3>
                <div className="dhpt-link-knoepfe">
                    {vorhanden(t.homepage) && <LinkKnopf href={alsUrl(t.homepage)} icon="pi pi-globe" label="Homepage" extern={true}/>}
                    {socialMedia && <LinkKnopf href={alsUrl(t.socialmedia)} icon={socialMedia.icon} label={socialMedia.label} extern={true}/>}
                    {vorhanden(t.email) && <LinkKnopf href={"mailto:" + t.email.trim()} icon="pi pi-envelope" label="E-Mail"/>}
                    {vorhanden(t.telefon) && <LinkKnopf href={"tel:" + telefonNummer} icon="pi pi-phone" label="Anrufen"/>}
                </div>
                {(vorhanden(t.email) || vorhanden(t.telefon)) &&
                    <dl className="dhpt-liste dhpt-kontakt">
                        {vorhanden(t.email) && <><dt>E-Mail</dt><dd>{t.email}</dd></>}
                        {vorhanden(t.telefon) && <><dt>Telefon</dt><dd>{t.telefon}</dd></>}
                    </dl>
                }
            </section>
        }

        {hatAustragungsort &&
            <section className="dhpt-karte">
                <h3 className="dhpt-karte-titel"><span>Austragungsort</span></h3>
                {vorhanden(t.austragungsortBezeichnung) && <div className="dhpt-fett">{t.austragungsortBezeichnung}</div>}
                {vorhanden(t.austragungsortStrasse) && <div>{t.austragungsortStrasse}</div>}
                {(vorhanden(t.austragungsortPLZ) || vorhanden(t.austragungsortOrt)) &&
                    <div>{[t.austragungsortPLZ, t.austragungsortOrt].filter(vorhanden).join(" ")}</div>
                }
                {(vorhanden(t.austragungsortPLZ) || vorhanden(t.austragungsortOrt)) &&
                    <div className="dhpt-link-knoepfe dhpt-abstand-oben">
                        <LinkKnopf href={getMapsUrl()} icon="pi pi-map-marker" label="In Google Maps öffnen" extern={true}/>
                    </div>
                }
            </section>
        }
    </div>
}
